/**
 * Null DTM Provider - no-op implementation
 */
export class NullDtmProvider {
    findLogUnit(_logUnit) {
        return false;
    }
    getSGVar(_sgArt) {
        return '';
    }
    getSGArt(_sgVar) {
        return '';
    }
    getVarWert(_varName) {
        return '';
    }
    setupGetVarWert(_varName) {
        return '';
    }
    setupGetStartPosition() { }
    setupGetNextAssoc() {
        return [false, '', ''];
    }
    logUnitEintragen(_logUnit) { }
    sgEintragen(_sgArt, _sgVar) { }
    loescheAuftrag() { }
    variableEintragen(_name, _value) { }
    variableLoeschen(_name) {
        return false;
    }
    loescheAlleVariablen() { }
    setupVariableEintragen(_name, _value) { }
    setupVariableLoeschen(_name) {
        return false;
    }
}
//# sourceMappingURL=dtm.js.map